<template>
  <div v-if="collections.length" class="uk-width-4-4@m mt-4 user-collections">
    <div class="course-grid-slider" uk-slider="finite: true">
      <div class="grid-slider-header">
        <div>
          <h4 class="uk-text-truncate">
            <i class="uil-notebooks"></i> {{ $t('menu_modules.collections') }}
          </h4>
        </div>
        <div class="grid-slider-header-link">
          <a class="slide-nav-prev" href="#" uk-slider-item="previous"></a>
          <a class="slide-nav-next" href="#" uk-slider-item="next"></a>
        </div>
      </div>
      <ul id="book-popular"
          class="uk-slider-items uk-child-width-1-2@m uk-child-width-1-3@s uk-grid-small uk-grid">
        <li v-for="collection in collections" :key="collection.id || collection.user_id || collection.name">
          <div class="book-popular-card">
            <img :src="collection.cover_image_link" alt="" class="cover-img">
            <div class="book-details">
              <a href="#">
                <h4>{{ collection.name }}</h4>
              </a>
              <p>
                <span v-if="collection.user_id == userData.id">
                  <i class="icon-feather-user"></i> {{ $t('general.personal') }}
                </span>
                <span v-else>
                  <i class="icon-feather-star"></i>
                  {{ collection.user ? collection.user.name + ' ' + collection.user.surname : '-' }}
                </span>
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserCollections',
  props: {
    collections: {
      type: Array,
      default: () => []
    },
    userData: {
      type: Object,
      required: true
    }
  }
};
</script>
